import { z } from 'zod/v4';

import { LoginResponseCode } from '@/enums/response-message/auth';

export const requestDataSchema = z.object({
  app_version: z.string().optional(),
  email: z
    .string({ message: 'Please eneter email address' })
    .min(1, { message: 'Please enter email address' })
    .email({ message: 'Please enter a valid email address' }),
  field_for_common_err: z.string().optional(),
  login_from: z.string().optional(),
  password: z
    .string({ message: 'Please enter password' })
    .min(1, { message: 'Please enter password' }),
  recaptcha_token: z.string().optional(),
});

export const verificationRequiredDataSchema = z.object({
  key: z.string(),
  mobile_number: z.string(),
  renew_after: z.number().positive(),
  reset_after: z.number().nullable().optional(),
});

export const loginDataSchema = z.object({
  access_token: z.string(),
  access_token_expiry: z.number(),
  bid_as: z.array(z.string()),
  bid_as_group: z.array(
    z.object({
      allowGovAuction: z.boolean().nullable(),
      biddingAid: z.string().nullable(),
      dealerCode: z.string(),
      name: z.string(),
      office: z.string(),
      status: z.string(),
      type: z.string(),
    }),
  ),
  dealer_group: z.array(z.any()),
  dealercode: z.string(),
  email: z.string().email(),
  group_id: z.number().nullable(),
  is_superadmin: z.boolean(),
  landing_page_name: z.string(),
  landing_page_url: z.string(),
  legacy_login_token: z.string(),
  mobile: z.string(),
  name: z.string(),
  quotz_dealer_name: z.string().nullable(),
  quotz_id: z.string().nullable(),
  quotz_is_gov_auction: z.boolean().nullable(),
  quotz_status: z.string().nullable(),
  status: z.number(),
  user_id: z.number(),
  user_permissions: z.array(z.string()),
  user_roles: z.array(z.string()),
});

export const responseSuccessSchema = z.object({
  data: loginDataSchema,
  message: z.literal(LoginResponseCode.ok),
  success: z.literal(true),
});

export const responseVerificationRequiredSchema = z.object({
  data: verificationRequiredDataSchema,
  message: z.literal(LoginResponseCode.login_verification_required),
  success: z.literal(true),
});

export const responseErrorSchema = z.object({
  data: z.array(z.string()),
  errors: z.array(z.string()),
  message: z.string(),
  success: z.literal(false),
});
